import { React } from '@/vendor'

export default (props) => (
	<svg width={21} height={17} viewBox="0 0 21 17" {...props}>
		<path d="M20 1.914a8.31 8.31 0 01-2.041 2.129v.537c0 5.42-4.121 11.67-11.66 11.67-2.315 0-4.492-.508-6.299-1.67.322.049.645.068.977.068 1.914 0 3.7-.83 5.087-1.943-1.777-.02-3.31-1.23-3.818-2.851.254.048.508.078.762.078.37 0 .742-.05 1.094-.147A4.1 4.1 0 01.81 5.762v-.05a4.113 4.113 0 001.855.509A4.083 4.083 0 01.83 2.822c0-.761.215-1.386.557-1.992 2.04 2.48 5.049 4.024 8.447 4.21a4.274 4.274 0 01-.088-.948A4.084 4.084 0 0113.838 0c1.182 0 2.246.508 3.017 1.29a8.237 8.237 0 002.588-.997 4.068 4.068 0 01-1.806 2.275A8.003 8.003 0 0020 1.914z" />
	</svg>
)
